var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{staticClass:"text-xs italic"},[_vm._v(" Sucursal: "+_vm._s(_vm.item.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }